export const state = {
  theme_appearance: 'light',
  mode: process.env.VUE_APP_ENV || 'development',
  crashNotification: false,
  bilingual: false,
  managementToken: false,
  bookSourceParam: [],
  trackvisionDemoId: [],
  serviceReport: false,
  driverScoreV2: {},

  cacheGeolocation: false,
  cacheGeolocationWhitelist: [],

  dataDogRumFlag: false,
  dataDogRumConfig: {},

  contractVendorAdditionalCostFlag: false,

  costEstimationFuel: false,

  freshchatSupport: false,

  systemNotification: false,

  integrationAccurateDOFlag: false,
  reportCostManagementFlag: false,
  reSyncDOAccurate: false,

  invoiceCoreFlag: false,

  inputDriverCostFlag: false,

  quickAssignmentShowIdleHistory: false,

  inputInvoiceV2Flag: false,

  marketPlaceFlag: false,

  urlCustomizationDashboard: null,

  reportDetailTripVersion: null,

  reportFuelVersion: null,

  reportTemperatureVersion: null,

  trackvision2StreamDemoId: null,

  trackvision2PlaybackDemoId: null,

  multiImei: false,

  multiImeiCT: false,
}

export const mutations = {
  setFeatureFlags(state, flags) {
    for (const [flag, value] of Object.entries(flags)) {
      state[flag] = value
    }
  },
}

export const getters = {
  getCrashNotification: (state) => {
    return state.crashNotification
  },
  getTrackvision2StreamDemoId: (state) => {
    return state.trackvision2StreamDemoId
  },
  getTrackvision2PlaybackDemoId: (state) => {
    return state.trackvision2PlaybackDemoId
  },
}
